/* Rose de Lille — gentle scroll reveal for collection sections only. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rdl-reveal-visible');
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.06
  });

  function register(root) {
    var sections = [];
    if (root.matches && root.matches('#MainContent .index-tab-collections')) sections.push(root);
    if (root.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll('#MainContent .index-tab-collections')));
    }
    sections.forEach(function (section) {
      if (section.classList.contains('rdl-reveal-pending')) return;
      section.classList.add('rdl-reveal-pending');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { register(document); }, { once: true });
  } else {
    register(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    register(event.target);
  });
})();

/* Collection cards: lightweight one-time entrance; cards never hidden before JS runs. */
(function(){
  'use strict';
  if(!document.body.classList.contains('template-collection'))return;
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(!entry.isIntersecting)return;
      entry.target.classList.add('rdl-collection-card-enter');
      observer.unobserve(entry.target);
    });
  },{root:null,rootMargin:'0px 0px -4% 0px',threshold:0.05});
  function observeCards(root){
    var items=root.querySelectorAll?root.querySelectorAll('#CollectionLoop > .product-item, #CollectionLoop > .grid-item.product-item'):[];
    Array.prototype.forEach.call(items,function(card){
      if(card.dataset.rdlCollectionMotion)return;
      card.dataset.rdlCollectionMotion='1';
      observer.observe(card);
    });
  }
  function boot(){
    observeCards(document);
    var grid=document.querySelector('[data-products-grid]');
    if(grid)new MutationObserver(function(changes){
      var inserted=false;
      changes.forEach(function(change){if(change.addedNodes.length)inserted=true;});
      if(inserted)observeCards(document);
    }).observe(grid,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(){observeCards(document);});
})();
